import React, { useCallback } from "react";
import TextField from "@material-ui/core/TextField";
import makeStyles from "@material-ui/core/styles/makeStyles";
import theme from "styles/theme";
import { DATATEST } from "constants/integration";
import { StringLengthCounter } from "./string-length-counter";

interface IProps {
    value: string;
    label: string;
    index: number;
    readonly?: boolean;
    onChange: (arg: { valueKey: string; value: string; displayValue: string }) => void;
    maxLimit: number;
}

export const MetadataTextAttribute: React.FC<IProps> = ({ value, label, onChange, readonly, index, maxLimit }) => {
    const classes = useStyles();

    const handleAttributeChange = useCallback(
        (event) => {
            let { value } = event.target;
            if (value.length > maxLimit) {
                value = value.slice(0, maxLimit);
            }
            onChange({ valueKey: event.target.name, value, displayValue: value });
        },
        [onChange, maxLimit],
    );

    return (
        <div className={classes.childAttribute} data-test={`${DATATEST.CUSTOMIZATIONS.CHILD_ATTRIBUTE}_${index}`}>
            <div className={classes.attributeLabel}>{label}:</div>

            <TextField
                name={`${index}`}
                value={value}
                onChange={handleAttributeChange}
                disabled={readonly}
                style={styles.childAttributeInput}
                InputProps={{
                    classes: {
                        input: classes.commentInput,
                    },
                    disableUnderline: true,
                }}
                helperText={<StringLengthCounter current={value.length} limit={maxLimit} />}
                inputProps={{
                    "data-test": DATATEST.CUSTOMIZATIONS.TEXT_CHILD_ATTRIBUTE,
                }}
                FormHelperTextProps={{
                    classes: {
                        error: classes.errorMessage,
                    },
                }}
            />
        </div>
    );
};

const useStyles = makeStyles({
    attributeLabel: {
        marginBottom: "5px",
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.textColor,
    },
    commentInput: {
        height: "40px !important",
        borderRadius: "5px !important",
        boxSizing: "border-box",
        fontSize: "16px !important",
    },
    childAttribute: {
        width: "45%",
        margin: "0 30px 29px 0",
    },
    errorMessage: {
        fontSize: "14px",
    },
});

const styles = {
    childAttributeInput: {
        width: "100%",
        height: "40px",
    },
};
